import React, { FC } from 'react';
import ContentContext from './content-context';

const { Provider } = ContentContext;

interface ContentProviderProps {
  data?: {
    markdownRemark?: {
      frontmatter: any;
    };
  };
}

const ContentProvider: FC<ContentProviderProps> = ({ data, children }) => (
  <Provider value={{ content: data?.markdownRemark?.frontmatter }}>{children}</Provider>
);

export default ContentProvider;
